import dayjs from 'dayjs';

import { ViewStyle } from './CategoryBannerView.style';
import { CATEGORY_BANNER_LINK_TYPE_LABEL, ATTACHMENT_TYPE } from './constants';
import { CategoryBannerSlideResponse } from '../../../../lib/api/category/categoryBannerType';

type CategoryBannerViewProps = {
  slides: CategoryBannerSlideResponse[];
};

// 동일 도메인의 날짜 처리는 모두 dayjs로 통일 (toLocaleDateString은 환경별 출력 차이 발생).
const formatDate = (dateStr: string): string => dayjs(dateStr).format('YYYY-MM-DD');

const formatExposurePeriod = (startDate: string, endDate: string | null): string =>
  endDate ? `${formatDate(startDate)} ~ ${formatDate(endDate)}` : `${formatDate(startDate)}부터 (무기한)`;

export const CategoryBannerView = ({ slides }: CategoryBannerViewProps) => {
  if (slides.length === 0) return null;

  return (
    <ViewStyle>
      <div className="slide-grid">
        {slides.map((slide, idx) => {
          const mobileImg = slide.attachments.find((a) => a.type === ATTACHMENT_TYPE.MOBILE);
          const pcImg = slide.attachments.find((a) => a.type === ATTACHMENT_TYPE.PC);

          return (
            <div key={slide.id} className="slide-card">
              <div className="slide-index">{idx + 1}</div>
              <div className="image-pair">
                <div className="image-slot">
                  <span className="image-label">MO</span>
                  {mobileImg && <img src={mobileImg.imageUrl} alt={`모바일 ${idx + 1}`} />}
                </div>
                <div className="image-slot">
                  <span className="image-label">PC</span>
                  {pcImg && <img src={pcImg.imageUrl} alt={`PC ${idx + 1}`} />}
                </div>
              </div>
              <div className="slide-meta">
                <div className="meta-row">
                  <span className="meta-label">링크</span>
                  <span className="meta-value">
                    {CATEGORY_BANNER_LINK_TYPE_LABEL[slide.linkType ?? 'none']}
                    {slide.linkType != null && (
                      <>
                        {slide.linkId != null && ` (ID: ${slide.linkId})`}
                        {slide.linkUrl && ` ${slide.linkUrl}`}
                      </>
                    )}
                  </span>
                </div>
                <div className="meta-row">
                  <span className="meta-label">기간</span>
                  <span className="meta-value">
                    {formatExposurePeriod(slide.startDate, slide.endDate)}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </ViewStyle>
  );
};
